export default __webpack_public_path__ + "static/media/job_6.f5a689e3.png";